import Bowser from "bowser";

export const clientEnvIsIOS = () => {
  if (!window.navigator.userAgent) return false;
  return Bowser.getParser(window.navigator.userAgent).getOSName(true) === "ios";
};
